<template>
  <div>
    <div class="">
      <!-- Tìm kiếm -->
      <div class="card mb-5 mb-3">
        <div class="card-header">
          <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
              tin cung cầu</span></h3>
        </div>
        <div class="card-body">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Mã sản phẩm:</label>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-input placeholder="Nhập mã sản phẩm" v-model="search.odooDefaultCode" />
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Tên sản phẩm:</label>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-input placeholder="Nhập tên sản phẩm " v-model="search.odooName" />
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Danh mục:</label>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-select placeholder="Tất cả" v-model="search.odooPublicCategIds" @onChange="handleSearch">
                    <el-option label="Tất cả" value="" selected></el-option>
                    <el-option v-for="item in categoryList" :key="item.odooId" :label="item.odooDisplayName"
                      :value="item.odooId.toString()"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Trạng thái:</label>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-select placeholder="Chọn trạng thái" v-model="search.odooIsPublished" @onChange="handleSearch">
                    <el-option label="Tất cả" value=""></el-option>
                    <el-option label="Published" value="1"></el-option>
                    <el-option label="Unpublished" value="0"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <label>Tình trạng:</label>
              <el-row :gutter="10">
                <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                  <el-select placeholder="Chọn tình trạng" v-model="search.nTinhTrang" @onChange="handleSearch">
                    <el-option label="Tất cả" value=""></el-option>
                    <el-option label="Hoạt động" value="1"></el-option>
                    <el-option label="Đã xóa" value="0"></el-option>
                  </el-select>
                </el-col>
                <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                  <el-button plain type="primary" title="Tìm kiếm" @click="findProduct"><i
                      class="fa fa-search"></i></el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>

      </div>
      <!-- Bảng sản phẩm -->
      <div class="card data-table mb-5 mb-xl-10">
        <div class="card-header py-3">
          <div style="padding: 5px 10px" class="form-row d-flex flex-row justify-content-between w-100">
            <div class="d-flex w-auto">
              <el-button type="primary" plain native-type="submit" @click="handleAdd">
                <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
                <span class="btn-inner--text">&nbsp;Thêm sản phẩm</span>
              </el-button>
            </div>

            <div class="d-flex w-auto">
              <el-button plain type="warning" style="margin-right:30px" title="Đồng bộ"
                @click="handleDataSync" v-loading.fullscreen.lock="isLoading"><i class="el-icon-refresh"></i></el-button>
              <!--               <el-button plain icon="el-icon-s-grid" ></el-button>-->
              <el-radio-group v-model="viewType"  class="viewType">
                <el-radio-button label="GRID" value="GRID" title="Lưới"><i class="fa fa-th"></i></el-radio-button>
                <el-radio-button label="TABLE" value="TABLE" title="Danh sách"><i class="fa fa-bars"></i></el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="col-md-12 tbl">
            <el-row :gutter="10" v-if="viewType == 'GRID'">
              <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6" v-for="item in tableData.content" :key="item.odooId"
                style="margin-bottom:10px">
                <div class="d-flex product-card" @click="showDetail(item)">
                  <el-avatar shape="square" :size="60" :fit="fit" :src="renderImg(item.odooImage1920)"></el-avatar>
                  <div>
                    <div class="product-name">{{ item.odooName }}</div>
                    <div class="product-text">[{{ item.odooDefaultCode }}]</div>
                    <div class="product-text">Đơn giá: {{ convertToMoney(item.odooListPrice) }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-table :data="tableData.content" header-row-class-name="thead-light" 
              style="height: 100%" height="100%" fit stripe highlight-current-row v-if="viewType == 'TABLE'">
              <el-table-column prop="odooDefaultCode" label="Mã sản phẩm" width="120"></el-table-column>
              <el-table-column prop="odooName" label="Tên sản phẩm" min-width="200">
                <template #default="scope">
                  <el-button type="text" @click="showDetail(scope.row)">{{ scope.row.odooName }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="odooListPrice" label="Giá bán" width="130">
                <template #default="scope">
                  {{ convertToMoney(scope.row.odooListPrice) }}
                </template>
              </el-table-column>
              <el-table-column prop="odooQuantity" label="Số lượng" width="130">
                <template #default="scope">
                  {{ scope.row.nSoLuong }}
                </template>
              </el-table-column>
              <el-table-column prop="odooPublicCategName" label="Danh mục" width="200">
                <template #default="scope">
                  <el-tag type="info" effect="dark" class="" v-for="item in scope.row.odooPublicCategName.split(',')" :key="item"
                    style="margin-left: 5px; border-radius: 20px;" :size="size">
                    {{ item }}
                  </el-tag>
                </template>
              </el-table-column>


              <el-table-column prop="odooIsPublished" label="Trạng thái" width="100" align="center">
                <template #default="scope">
                  <el-tag type="success" effect="dark" v-if="scope.row.odooIsPublished == 1" :size="size">
                    Published
                  </el-tag>
                  <el-tag type="warning" effect="dark" v-else :size="size">
                    Unpublished
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="dNgayTao" label="Ngày tạo" width="120" align="center">
                <template #default="scope">
                  <span v-if="scope.row.dNgayTao">{{
                    momentDate(scope.row.dNgayTao)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="nTinhTrang" label="Tình trạng" width="120" align="center">
                <template #default="scope">
                  <el-tag type="success" v-if="scope.row.nTinhTrang == 1" :size="size">Hoạt Động</el-tag>
                  <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" :size="size">Đã xóa</el-tag>
                </template>
              </el-table-column>

              <!-- Button hành động -->
              <el-table-column width="160" align="center">
                <template #default="scope">
                  <!-- <el-button
                  :disabled="scope.row.nTinhTrang == 0"
                  :size="size"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  ><i class="el-icon-edit mr-1"></i>Sửa</el-button
                > -->

                  <!-- <el-button
                  :disabled="scope.row.nTinhTrang == 0"
                  :size="size"
                  type="danger"
                  @click="deleteProduct(scope.$index, scope.row)"
                  ><i class="el-icon-delete mr-1"></i>Xóa</el-button
                > -->
                  <el-button type="primary" plain @click="handleEdit(scope.$index, scope.row)"
                    :disabled="scope.row.nTinhTrang == 0">
                    <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                  </el-button>

                  <el-button type="danger" plain @click="deleteProduct(scope.$index, scope.row)"
                    :disabled="scope.row.nTinhTrang == 0" v-loading.fullscreen.lock="isLoading">
                    <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="col-12 py-2 pagination" style="justify-content: end">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <el-dialog v-model="centerDialogVisible" class="modalTemp" :show-close="false" dataBackDrop="static">
      <template #header="{ close, titleId, titleClass }">
        <div class="d-flex justify-content-between px-4 pt-4">
          <h2 slot="header" class="modal-title">
            {{ operation ? "Cập nhật thông tin sản phẩm" : "Thêm sản phẩm" }}
          </h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
            @click="centerDialogVisible = false">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
      </template>
      <el-form :model="validateForm" :rules="rules" ref="validateForm" label-width="150px"
        class="demo-ruleForm flex-column">
        <el-form-item label="Mã sản phẩm" prop="odooDefaultCode">
          <el-input v-model="validateForm.odooDefaultCode" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Tên sản phẩm" prop="odooName">
          <el-input v-model="validateForm.odooName" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="Giá bán" prop="odooListPrice">
          <el-input-number v-model="validateForm.odooListPrice" :min="0" style="width: 30%;"></el-input-number>
        </el-form-item>

        <el-form-item label="Danh mục" prop="odooPublicCategIds">
          <el-select v-model="validateForm.odooPublicCategIds" multiple placeholder="Chọn danh mục" style="width: 30%;">
            <el-option v-for="item in categoryList" :key="item.odooId" :label="item.odooDisplayName"
              :value="item.odooId.toString()">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Số lượng" prop="nSoLuong">
          <el-input-number v-model="validateForm.nSoLuong" :min="0" style="width: 30%;"></el-input-number>
        </el-form-item>

        <el-form-item label="Hình ảnh">
          <el-upload action="#" :auto-upload="false" list-type="picture-card" :on-change="onImgChange"
            :file-list="fileList" :on-remove="onImgRemove" accept="image/*">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button v-if="!operation" type="primary" @click="saveProduct()"
          v-loading.fullscreen.lock="isLoading">Thêm</el-button>
        <el-button v-if="operation" type="primary" @click="saveProduct()"
          v-loading.fullscreen.lock="isLoading">Lưu</el-button>
        <el-button v-if="operation" plain type="danger" @click="closeForm">Thoát</el-button>
        <el-button v-if="!operation" plain type="danger" @click="closeForm1">Thoát</el-button>
      </template>
    </el-dialog>

    <product-detail :show="detailDialog" @hideDialog="hideDialog" :data="selectedItem"></product-detail>

  </div>
</template>

<script>
import moment from "moment";
import { convertToMoney } from "@/utils/stringUtils";
import { baseUrl } from "@/utils/global"
import ProductDetail from "./ProductDetail.vue"
import _ from 'lodash';
import { useStore } from "vuex";
import { Common, Product } from "@/store/enums/StoreEnums";
import { ElMessage } from "element-plus";
export default {
  components: {
    ProductDetail
  },
  data() {
    return {
      size: "",
      viewType: "TABLE",
      rules: {
        odooName: [
          { required: true, message: "Bạn chưa nhập tên sản phẩm", trigger: "blur", },
        ],
        odooListPrice: [
          { required: true, message: "Bạn chưa nhập đơn giá", trigger: "blur" },
        ],
        odooPublicCategIds: [
          { required: true, message: "Bạn chưa chọn danh mục", trigger: "blur" },
        ],
      },
      categoryList: [],
      isLoading: false,
      isSearchLoading: false,
      tableData: [],
      search: {
        odooDefaultCode: "",
        odooName: "",
        odooIsPublished: "",
        odooPublicCategIds: "",
        nTinhTrang: "1",
      },
      pageRequest: { pageNum: 1, pageSize: 30 },
      operation: false,
      centerDialogVisible: false,
      validateForm: {
        odooDefaultCode: "",
        odooName: "",
        odooListPrice: "",
        odooPublicCategIds: [],
        odooIsPublished: "",
        nSoLuong: "",
      },
      fileList: [],
      detailDialog: false,
      fit: "cover",
      srcList: [""],
      selectedItem: null,
      store: useStore()
    };
  },
  methods: {

    renderImg(img) {
      return baseUrl + '/product/img/' + img
    },

    convertToMoney(num) {
      return convertToMoney(num) + "đ";
    },

    showDetail(row) {
      this.selectedItem = row.odooId
      this.detailDialog = true
    },

    hideDialog() {
      this.detailDialog = false
    },

    onImgChange(file, fileList) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        ElMessage({ message: 'Kích thước ảnh phải nhỏ hơn 1MB!', type: "error" });
        this.fileList = []
      }
      else
        this.fileList = [file]
    },

    onImgRemove(file, fileList) {
      if (file.status === "success") this.validateForm.odooImage1920 = ""
      this.fileList = []
    },

    handleAdd() {
      this.validateForm = {
        odooDefaultCode: "",
        odooName: "",
        odooListPrice: "",
        odooPublicCategIds: [],
        odooIsPublished: "",
        nSoLuong: "",
      };
      this.srcList = [""]
      this.operation = false;
      this.centerDialogVisible = true
    },

    handleEdit(index, item) {
      let data = Object.assign({}, item);

      if (data.odooImage1920) this.fileList = [{ name: data.odooImage1920, url: this.renderImg(data.odooImage1920) }]
      data.odooPublicCategIds = data.odooPublicCategIds.split(',')
      this.validateForm = Object.assign({}, data);
      this.srcList = [""]
      this.operation = true

      this.$nextTick(() => {
        this.centerDialogVisible = true
      });
    },

    handleSearch() {
      this.findProduct();
    },

    closeForm() {
      this.fileList = []
      this.$refs.validateForm.resetFields();
      this.centerDialogVisible = false;
    },
    closeForm1() {
      this.fileList = []
      this.$refs.validateForm.resetFields();
      this.centerDialogVisible = false;
    },

    findProduct(pageNum, pageSize) {
      this.isSearchLoading = true
      if (typeof pageNum == "number") this.pageRequest.pageNum = pageNum;
      else this.pageRequest.pageNum = 1;

      if (typeof pageSize == "number") this.pageRequest.pageSize = pageSize;
      else this.pageRequest.pageSize = 30;

      this.pageRequest.columnFilters = {
        odooDefaultCode: { value: this.search.odooDefaultCode },
        odooName: { value: this.search.odooName },
        odooIsPublished: { value: this.search.odooIsPublished },
        odooPublicCategIds: { value: this.search.odooPublicCategIds },
        nTinhTrang: { value: this.search.nTinhTrang },
      };

      this.store.dispatch(Product.findPageProduct, this.pageRequest).then((res) => {
        this.isSearchLoading = false
        if (res.code == 200 && res.data)
          this.tableData = res.data;
        else
          this.tableData = []
      });
    },

    saveProduct() {
      this.$refs.validateForm.validate((valid) => {
        if (valid) {
          this.isLoading = true
          let params = Object.assign({}, this.validateForm);
          params.odooPublicCategIds = params.odooPublicCategIds.toString()

          const formData = new FormData();
          if (this.fileList.length > 0) {
            this.fileList.forEach(e => {
              if (e.status === "ready") formData.append('image', e.raw);
            })
          }
          formData.append('data', new Blob([JSON.stringify(params)], { type: "application/json" }));


          this.store.dispatch(Product.saveProduct, formData).then((res) => {
            this.isLoading = false
            if (res.code == 200) {
              if (this.operation == false) {
                ElMessage({ message: "Thêm sản phẩm thành công!", type: "success", });
              } else {
                ElMessage({
                  message: "Cập nhật sản phẩm thành công!",
                  type: "success",
                });
              }
              this.closeForm();
              this.findProduct();
            } else {
              if (this.operation == false) {
                ElMessage({
                  message: "Thêm sản phẩm thất bại! " + res.msg,
                  type: "error",
                });
              } else {
                ElMessage({
                  message: "Cập nhật sản phẩm thất bại!" + res.msg,
                  type: "error",
                });
              }
            }
          });
        }
      });
    },

    deleteProduct(index, item) {
      this.$confirm("Bạn có muốn xóa sản phẩm này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.isLoading = true
          this.store.dispatch(Product.deleteProductRecord, item).then((res) => {
            this.isLoading = false
            if (res.code == 200) {
              ElMessage({
                message: `Xóa thành công sản phẩm ${item.odooName}`,
                type: "success",
              });
              this.findProduct();
            } else {
              ElMessage({ message: `Xóa thất bại, ` + res.msg, type: "error" });
            }
          });
        })
        .catch(() => { });
    },

    handleDataSync() {
      try {
        this.isLoading = true
        this.store.dispatch(Product.dataSyncProduct).then((res) => {
          this.isLoading = false
          if (res.code == 200) {
            ElMessage({ message: res.msg, type: "success", });
            this.findProduct();
          } else {
            ElMessage({ message: `Đồng bộ thất bại, ` + res.msg, type: "error" });
          }
        });
      }
      catch (ex) {
        console.log(ex);
        this.isLoading = false
      }
    },

    handleSizeChange(val) {
      this.findProduct(this.pageRequest.pageNum, val);
    },

    handleCurrentChange(val) {
      this.findProduct(val, this.pageRequest.pageSize);
    },

    getCategoryList() {
      this.store.dispatch(Common.getCategoryList).then((res) => {
        if (res.code == 200 && res.data)
          this.categoryList = res.data
        else
          this.categoryList = []
      })
    },

    debounceSearchText: _.debounce(function () {
      this.handleSearch()
    }, 500),
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    }
  },
  mounted() {
    this.findProduct()
    this.getCategoryList()
  },
  watch: {
    'search.odooDefaultCode': function () {
      this.debounceSearchText()
    },
    'search.odooName': function () {
      this.debounceSearchText()
    }
  }
};
</script>

<style lang="scss" scoped>
.tbl {
  height: calc(100vh - 255px);
}

.box-card {
  margin: 10px;
}

.product-card {
  padding: 5px;
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  align-items: center;
  cursor: pointer;
}

.product-name {
  font-size: 13px;
  font-weight: 500;
  margin-left: 5px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.product-text {
  font-size: 13px;
  margin-left: 5px;
}

.viewType label {
  margin-bottom: 0rem;
}
</style>

<style>
.modalTemp .modal-body {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.card-header {
  padding: 0px;
}

.font-details {
  font-size: 18px;
  font-weight: 500;
}
</style>
